import { useCallback, useState } from "react";

export const useGeolocation = () => {
  const [coords, setCoords] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const locate = useCallback(
    () =>
      new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
          setError("gpsDenied");
          reject(new Error("gpsDenied"));
          return;
        }
        setLoading(true);
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            const value = {
              latitude: pos.coords.latitude,
              longitude: pos.coords.longitude,
              accuracy: pos.coords.accuracy,
            };
            setCoords(value);
            setError(null);
            setLoading(false);
            resolve(value);
          },
          (err) => {
            setError("gpsDenied");
            setLoading(false);
            reject(err);
          },
          { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 }
        );
      }),
    []
  );

  return { coords, error, loading, locate };
};
